<div [ngClass]="{ 'tooltip': isTooltip, 'popup': !isTooltip }" [ngStyle]="{ 'top.px': top, 'right.px': right }"
  [class]="'bg-white rounded-2xl hidden lg:block shadow-md !z-50 p-4 border-[1px] after:!-z-10 border-gray-200 after:w-5 after:h-5 after:rotate-45 after:bg-white after:absolute after:-bottom-2 after:shadow-sm after:rounded-md ' + classList"
  [@popUpAnimation]="isVisible ? 'visible' : 'hidden'">
  <ng-container *ngIf="isVisible">
    <ng-content></ng-content>
    <div class="tooltip-content">
      <ng-container *ngTemplateOutlet="popUpTemplate"></ng-container>
    </div>
  </ng-container>
</div>